import React from 'react';
import { Link } from 'react-router-dom';
import { FaCalendar } from 'react-icons/fa';
import CustomImage from '../common/CustomImage';
import './SimpleBlogCard.css';

const SimpleBlogCard = ({ blog }) => {
  console.log('SimpleBlogCard received blog:', blog);
  console.log('Blog heroImage:', blog?.heroImage);
  console.log('Blog heroImage type:', typeof blog?.heroImage);
  console.log('Publication date value:', blog?.publicationDate);
  console.log('Publication date type:', typeof blog?.publicationDate);

  const formatDate = (dateString) => {
    console.log('formatDate received:', dateString);
    if (!dateString) return 'No date available';
    try {
      const date = new Date(dateString);
      console.log('Parsed date:', date);
      const formattedDate = date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
      console.log('Formatted date:', formattedDate);
      return formattedDate;
    } catch (error) {
      console.error('Error formatting date:', error);
      return 'Invalid date';
    }
  };

  return (
    <div className="simple-blog-card">
      <div className="simple-image-container">
        <CustomImage
          src={blog?.heroImage}
          alt={blog?.title || 'Blog post image'}
          className="simple-image"
          fallbackSrc="/images/blog-placeholder.jpg"
        />
      </div>
      <div className="simple-content">
        <div className="simple-meta">
          <span className="simple-date">
            <FaCalendar /> {formatDate(blog?.publicationDate)}
          </span>
        </div>
        <h3 className="simple-title">
          <Link to={`/blog/${blog?.slug || blog?._id}`}>{blog?.title}</Link>
        </h3>
        <p className="simple-excerpt">{blog?.excerpt}</p>
        <Link to={`/blog/${blog?.slug || blog?._id}`} className="simple-read-more">
          Read More
        </Link>
      </div>
    </div>
  );
};

export default SimpleBlogCard; 